module.exports = __webpack_public_path__ + "img/NoiseAware_GooglePlayStore.66c6cc62.png";